import localeAntd from 'antd/es/locale/fr_FR'
import messages from './fr.json'

export default {
  locale: 'fr-FR',
  localeAntd,
  messages
}
